import React from 'react';
import {CMSLandingAccordion, CMSLandingAccordionItem} from '@tempo/landing';
import {Box, Button} from '@tempo/core';
import Link from 'next/link';
import {useResolveTranslations} from '../hooks/useResolveTranslations';

type StrapiFaqBlockProps = {
	strapiBlockData: any;
	translationNamespace: string;
};

export const StrapiFaqBlock: React.FC<StrapiFaqBlockProps> = ({
	strapiBlockData,
	translationNamespace,
}) => {
	const resolve = useResolveTranslations(translationNamespace);
	return (
		<Box
			bg="background.neutral.primary.default"
			py="spacing.3xl"
			maxW="900px"
			mx="auto"
		>
			<CMSLandingAccordion
				title={resolve(strapiBlockData.title).replace(/<[^>]+>/g, '')}
				cta={
					<Button as={Link} href={strapiBlockData.cta?.href} variant="outline">
						{resolve(strapiBlockData.cta?.label).replace(/<[^>]+>/g, '')}
					</Button>
				}
			>
				{strapiBlockData.questionAnswers.map((qa: any) => (
					<CMSLandingAccordionItem
						key={qa.id}
						label={resolve(qa.question).replace(/<[^>]+>/g, '')}
						defaultOpen={qa.defaultOpen}
					>
						{resolve(qa.answer).replace(/<[^>]+>/g, '')}
					</CMSLandingAccordionItem>
				))}
			</CMSLandingAccordion>
		</Box>
	);
};
